
    $('.js-desctop-filter-form .filter-item input[type="checkbox"]').on('change',function (){
        const form = $(this).closest('.js-desctop-filter-form');
        setTimeout(function (){
            form.trigger('submit');
        },200)
    })
    $('.js-sorting').on("change",function (){
        const formDesctop = $('.js-desctop-filter-form');
        const formMobile = $('.js-mobile-filter-form');
        if (window.matchMedia("(max-width: 768px)").matches) {
            const input = formMobile.find('.sorting');
            if(input.length > 0){
                input.val(this.options[this.selectedIndex].value);
            }else{
                formMobile.append($(`<input class="sorting" type="hidden" name="sort_by" value="${this.options[this.selectedIndex].value}">`))
            }
            setTimeout(function (){
                formMobile.trigger('submit');
            },200)
        } else {
        
           const input = formDesctop.find('.sorting');
            if(input.length > 0){
                input.val(this.options[this.selectedIndex].value);
            }else{
                formDesctop.append($(`<input class="sorting" type="hidden" name="sort_by" value="${this.options[this.selectedIndex].value}">`))
            }
            setTimeout(function (){
                formDesctop.trigger('submit');
            },200)
        }

    });
    $('.control-item.list:not(.selected)').on('click',function (){
        const listInput= '<input class="product-view" type="hidden" name="view" value="list">'
        const formDesctop = $('.js-desctop-filter-form');
        const formMobile = $('.js-mobile-filter-form');
        if (window.matchMedia("(max-width: 768px)").matches) {
            formMobile.append(listInput);
            setTimeout(function (){
                formMobile.trigger('submit');
            },200)
        } else {
            formDesctop.append(listInput);
            setTimeout(function (){
                formDesctop.trigger('submit');
            },200)
        }
    })
    $('.control-item.grid:not(.selected)').on('click',function (){
        const formDesctop = $('.js-desctop-filter-form');
        const formMobile = $('.js-mobile-filter-form');
        if (window.matchMedia("(max-width: 768px)").matches) {
            formMobile.find('.product-view').remove();
            setTimeout(function (){
                formMobile.trigger('submit');
            },200)
        } else {
            formDesctop.find('.product-view').remove();
            setTimeout(function (){
                formDesctop.trigger('submit');
            },200)
        }
    })
    $('.mobile-filter-item .filter-title').on('click',function (){
        $(this).closest('.mobile-filter-item').find('.filter-item-wrapper').addClass('open');
    });
    $('.mobile-filter-item .filter-values-header .header-title').on('click',function (){
        $(this).closest('.mobile-filter-item').find('.filter-item-wrapper').removeClass('open');
    });
    $('.js-desctop-filter-form .filter-title').on('click',function (){
        $(this).closest('.filter-item').toggleClass('open')
    });
    $('.js-mobile-filter-form .mobile-filter-close').on('click',function (){
        $(this).closest('.js-mobile-filter-form').removeClass('open');
        $('body').removeClass('filter-open');
    });
    $('.js-open-filter').on('click',function (){
        $('.js-mobile-filter-form').addClass('open');
        $('body').addClass('filter-open');
    });
    $('.js-clear-checkbox').on('click',function (){
        const checkboxWrapper = $(this).closest('.filter-item-wrapper');
        checkboxWrapper.find('input[type="checkbox"]').each(function (){
            this.removeAttribute('checked');
            this.checked = false;
        })
    });
    $('.js-remove-value').on('click',function (e){
        // e.preventDefault()
        const linkUrl = $(this).attr('href').split('?')
        const sectionId = 'collection-template';
        // updateFilter(linkUrl[0],linkUrl[1],sectionId)
    });
$(document).on('submit','.js-desctop-filter-form',function (e){
    // e.preventDefault()
    const formData = new FormData(this);
    const searchParams = new URLSearchParams(formData).toString();
    const url = this.getAttribute('data-url');
    const sectionId = 'collection-template';
    // updateFilter(url,searchParams,sectionId)
});
$(document).on('submit','.js-mobile-filter-form',function (e){
    // e.preventDefault()
    const formData = new FormData(this);
    const searchParams = new URLSearchParams(formData).toString();
    const url = this.getAttribute('data-url');
    const sectionId = 'collection-template';
    // updateFilter(url,searchParams,sectionId)
});
function updateFilter(url,searchParams,sectionId){
    $('.product-grid-wrapper').addClass('loading')
    fetch(url+`?${searchParams}` + `&section_id=${sectionId}`).then(function (response) {
        return response.text();
    }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        let catalog = doc.querySelector('.product-grid-wrapper');
        let desktopForm = doc.querySelector('.js-desctop-filter-form');
        let mobileForm = doc.querySelector('.js-mobile-filter-form');
        $('.product-grid-wrapper')[0].innerHTML=catalog.innerHTML;
        $('.js-desctop-filter-form')[0].innerHTML=desktopForm.innerHTML;
        $('.js-mobile-filter-form')[0].innerHTML=mobileForm.innerHTML;
        $('.js-mobile-filter-form').removeClass('open')
        $('body').removeClass('filter-open');
        console.log('reload')
        reloadEvents();
        $('.product-grid-wrapper').removeClass('loading')
        window.history.replaceState({ }, '', url+`?${searchParams}`);
    }).catch(function (err) {

        console.error('Something went wrong.', err);
    });
}
function reloadEvents(){
    $('.js-desctop-filter-form .filter-item input[type="checkbox"]').on('change',function (){
        const form = $(this).closest('.js-desctop-filter-form');
        setTimeout(function (){
            form.trigger('submit');
        },200)
    })
    $('.js-sorting').on("change",function (){
        const formDesctop = $('.js-desctop-filter-form');
        const formMobile = $('.js-mobile-filter-form');
        if (window.matchMedia("(max-width: 768px)").matches) {
            const input = formMobile.find('.sorting');
            if(input.length > 0){
                input.val(this.options[this.selectedIndex].value);
            }else{
                formMobile.append($(`<input class="sorting" type="hidden" name="sort_by" value="${this.options[this.selectedIndex].value}">`))
            }
            setTimeout(function (){
                formMobile.trigger('submit');
            },200)
        } else {
            const input = formDesctop.find('.sorting');
            if(input.length > 0){
                input.val(this.options[this.selectedIndex].value);
            }else{
                formDesctop.append($(`<input class="sorting" type="hidden" name="sort_by" value="${this.options[this.selectedIndex].value}">`))
            }
            setTimeout(function (){
                formDesctop.trigger('submit');
            },200)
        }

    });
    $('.control-item.list:not(.selected)').on('click',function (){
        const listInput= '<input class="product-view" type="hidden" name="view" value="list">'
        const formDesctop = $('.js-desctop-filter-form');
        const formMobile = $('.js-mobile-filter-form');
        if (window.matchMedia("(max-width: 768px)").matches) {
            formMobile.append(listInput);
            setTimeout(function (){
                formMobile.trigger('submit');
            },200)
        } else {
            formDesctop.append(listInput);
            setTimeout(function (){
                formDesctop.trigger('submit');
            },200)
        }
    })
    $('.control-item.grid:not(.selected)').on('click',function (){
        const formDesctop = $('.js-desctop-filter-form');
        const formMobile = $('.js-mobile-filter-form');
        if (window.matchMedia("(max-width: 768px)").matches) {
            formMobile.find('.product-view').remove();
            setTimeout(function (){
                formMobile.trigger('submit');
            },200)
        } else {
            formDesctop.find('.product-view').remove();
            setTimeout(function (){
                formDesctop.trigger('submit');
            },200)
        }
    })
    $('.mobile-filter-item .filter-title').on('click',function (){
        $(this).closest('.mobile-filter-item').find('.filter-item-wrapper').addClass('open');
    });
    $('.mobile-filter-item .filter-values-header .header-title').on('click',function (){
        $(this).closest('.mobile-filter-item').find('.filter-item-wrapper').removeClass('open');
    });
    $('.js-desctop-filter-form .filter-title').on('click',function (){
        $(this).closest('.filter-item').toggleClass('open')
    });
    $('.js-mobile-filter-form .mobile-filter-close').on('click',function (){
        $(this).closest('.js-mobile-filter-form').removeClass('open');
        $('body').removeClass('filter-open');
    });
    $('.js-open-filter').on('click',function (){
        $('.js-mobile-filter-form').addClass('open');
        $('body').addClass('filter-open');
    });
    $('.js-clear-checkbox').on('click',function (){
        const checkboxWrapper = $(this).closest('.filter-item-wrapper');
        checkboxWrapper.find('input[type="checkbox"]').each(function (){
            this.removeAttribute('checked');
            this.checked = false;
        })
    });
    $('.js-remove-value').on('click',function (e){
        // e.preventDefault()
        const linkUrl = $(this).attr('href').split('?')
        const sectionId = 'collection-template';
        // updateFilter(linkUrl[0],linkUrl[1],sectionId)
    });
}